// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__2KjGu","radius":"Button_radius__qT7Dm","danger":"Button_danger__1OQ69","outline":"Button_outline__3Z799","primary":"Button_primary__18YIC"};